import { store } from "../stores";
import { setModalOpen, setHasDeviceToken, setPermissionStatus, checkDeviceToken } from "../stores/notificationPermission";

/**
 * Checks if device token is available in localStorage
 */
export const checkDeviceTokenAvailability = (): boolean => {
  const stored = localStorage.getItem("deviceToken");
  const hasToken = !!(stored && stored.trim());
  
  // Update store with current state
  store.dispatch(setHasDeviceToken(hasToken));
  store.dispatch(setPermissionStatus(Notification.permission));
  
  return hasToken;
};

/**
 * Shows notification permission modal if device token is not available
 * and notification permission is not granted
 */
export const checkAndPromptForNotificationPermissions = (): boolean => {
  const hasToken = checkDeviceTokenAvailability();
  const permission = Notification.permission;
  
  // If we don't have token and permission is not denied, show modal
  if (!hasToken && permission !== 'granted') {
    store.dispatch(setModalOpen(true));
    return false; // Token not available
  }
  
  return hasToken; // Token is available
};

/**
 * Manually trigger the notification permission modal
 */
export const showNotificationPermissionModal = () => {
  store.dispatch(setModalOpen(true));
};

/**
 * Hide the notification permission modal
 */
export const hideNotificationPermissionModal = () => {
  store.dispatch(setModalOpen(false));
};

/**
 * Get current notification permission state
 */
export const getNotificationPermissionState = () => {
  const state = store.getState();
  return {
    hasDeviceToken: state.notificationPermission.hasDeviceToken,
    permissionStatus: state.notificationPermission.permissionStatus,
    isModalOpen: state.notificationPermission.isModalOpen,
  };
};